export const attach = () => {}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/override.js